import { MonthlyReportTable } from '@/features/payment-management/affiliate-log/monthly-report/table';
import { MonthlyReportData } from '@/services/payment/payment.types';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'requestId',
    'requestedDate',
    'bankType',
    'bankInfo',
    'accountSymbol',
    'accountNumber',
    'accountHolderName',
    'requestedAmount',
    'status',
    'remarks',
  ]),
  desc: z.boolean(),
});

const storeSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
});

export const Route = createFileRoute('/(app)/payment-management/affiliate-log/$monthly-report')({
  component: RouteComponent,
  validateSearch: (search: MonthlyReportData) => storeSearchSchema.parse(search),
});

const dummyMonthlyReportData: MonthlyReportData[] = Array.from({ length: 15 }).map((_, index) => {
  const statuses: ('PENDING' | 'APPROVED' | 'REJECTED')[] = ['PENDING', 'APPROVED', 'REJECTED'];
  return {
    sn: String(index + 1),
    id: `req-00${index + 1}`,
    requestId: `REQ-2024-0${index + 1}`,
    requestedDate: `2024-03-${String((index % 28) + 1).padStart(2, '0')}`,
    bankType: index % 2 === 0 ? 'SAVINGS' : 'CHECKING',
    bankInfo: index % 2 === 0 ? 'Mitsubishi UFJ Bank' : 'Sumitomo Mitsui Bank',
    accountSymbol: index % 2 === 0 ? '三菱' : '三井',
    accountNumber: `1234567${index}`,
    accountHolderName: index % 2 === 0 ? 'John Doe' : 'Jane Smith',
    requestedAmount: 5000 + index * 1000,
    status: statuses[index % 3],
    remarks: index % 3 === 2 ? 'Incomplete details' : '',
  };
});

function RouteComponent() {
  // const { monthlyReportData } = useMonthlyReport();
  return <MonthlyReportTable data={dummyMonthlyReportData} />;
}
